<template>
  <div class="basket">
    <div class="basket-title" @click="onShow">
      <i class="el-icon-shopping-bag-2"></i
      ><span>{{ $t("basket.title") }}</span>
      <i class="el-icon-arrow-down" v-if="show"></i>
      <i class="el-icon-arrow-up" v-else></i>
    </div>
    <div class="basket-container" v-if="show">
      <tabPane
        :tab-list="tabNav"
        :active="activeTab"
        @updateActive="updateTabNav"
      >
        <div slot="first">
          <div class="basket-content">
            <div v-if="basket.products && basket.products.length > 0">
              <div
                class="product"
                v-for="(product, index) in basket.products"
                :key="index"
              >
                <span @click="toDetail(product.PId)">
                  <div class="product-left">
                    <div class="image">
                      <el-image
                        :src="imgUrlFilter(product.ProductImage)"
                        fit="cover"
                      ></el-image>
                    </div>
                  </div>
                  <div class="product-right">
                    <div class="companyName">{{ product.CompanyName }}</div>
                    <div class="productName">{{ product.ProductName }}</div>
                  </div>
                </span>
                <div class="product-btns">
                  <el-button
                    icon="el-icon-close"
                    size="mini"
                    circle
                    @click="onDelete(product.PId, 1)"
                  ></el-button>
                </div>
              </div>
            </div>
            <div class="basket-empty" v-else>
              <el-empty :description="$t('basket.noData')" :image-size="100"></el-empty>
            </div>
          </div>
        </div>
        <div slot="second">
          <div class="basket-content">
            <div v-if="basket.suppliers && basket.suppliers.length > 0">
              <div
                class="supplier"
                v-for="(supplier, index) in basket.suppliers"
                :key="index"
              >
                <span @click="toBusiness(supplier.ShopId)">
                  <div class="supplier-left">
                    <div class="image">
                      <el-image
                        :src="imgUrlFilter(supplier.CompanyLogo)"
                        fit="cover"
                      ></el-image>
                    </div>
                  </div>
                  <div class="supplier-right">
                    <div class="companyName">{{ supplier.CompanyName }}</div>
                  </div>
                </span>
                <div class="supplier-btns">
                  <el-button
                    icon="el-icon-close"
                    size="mini"
                    circle
                    @click="onDelete(supplier.ShopId, 2)"
                  ></el-button>
                </div>
              </div>
            </div>
            <div class="basket-empty" v-else>
              <el-empty :description="$t('basket.noData')" :image-size="100"></el-empty>
            </div>
          </div>
        </div>
      </tabPane>
      <div class="basket-footer" v-if="activeTab == 'first'">
        <el-button
          class="submit-button"
          type="warning"
          @click="handleSubmit"
          :disabled="basket && basket.products.length == 0 ? true : false"
          >{{ $t("basket.submit") }}</el-button
        >
        <el-button
          class="clear-button"
          @click="onClear"
          :disabled="basket && basket.products.length == 0 ? true : false"
          >{{ $t("basket.clear") }}</el-button
        >
      </div>
      <div class="basket-footer" v-if="activeTab == 'second'">
        <el-button
          class="submit-button"
          type="warning"
          @click="handleSubmit"
          :disabled="basket && basket.suppliers.length == 0 ? true : false"
          >{{ $t("basket.submit") }}</el-button
        >
        <el-button
          class="clear-button"
          @click="onClear"
          :disabled="basket && basket.suppliers.length == 0 ? true : false"
          >{{ $t("basket.clear") }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { DELETE_BASKET, CLEAR_BASKET } from "../../store/mutation-types";
import tabPane from "./basketTab.vue";

export default {
  name: "basket",
  props: {},
  components: { tabPane },
  data() {
    return {
      show: false,
      activeTab: "first",
      tabNav: [
        {
          label: this.$t("basket.product"),
          name: "first"
        },
        {
          label: this.$t("basket.supplier"),
          name: "second"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      basket: state => state.supplier.basket
    })
  },
  created() {
    var bus = this.$bus.$off("showBasket");
    if (bus) {
      bus.$on("showBasket", val => {
        this.show = val.show;
        this.updateTabNav(val.activeTab, true);
      });
    }
  },
  methods: {
    ...mapMutations([DELETE_BASKET, CLEAR_BASKET]),
    updateTabNav(val, isChange) {
      this.activeTab = val;
      if (isChange) {
        this.$bus.$emit("changeBasketTab", val);
      }
    },
    onClear() {
      if (this.activeTab == "first") {
        this.CLEAR_BASKET({ type: 1 });
      } else {
        this.CLEAR_BASKET({ type: 2 });
      }
    },
    onDelete(id, type) {
      this.DELETE_BASKET({ id: id, type: type });
    },
    onShow() {
      this.show = !this.show;
    },
    toDetail(productNumber) {
      let routeUrl = this.$router.resolve({
        path: "/commodity",
        query: { ProductNumber: productNumber }
      });
      window.open(routeUrl.href, "_blank");
    },
    toBusiness(ShopId) {
      let routeUrl = this.$router.resolve({
        path: "/business",
        query: { ShopId: ShopId }
      });
      window.open(routeUrl.href, "_blank");
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    handleSubmit() {
      var ids = [];
      if (this.activeTab == "first") {
        for (const product of this.basket.products) {
          if (product.PId) {
            ids.push(product.PId);
          }
        }
        let productUrl = this.$router.resolve({
          path: "/enquiry",
          query: { PIdList: ids, IsDetail: true }
        });
        window.open(productUrl.href, "_blank");
      } else {
        for (const supplier of this.basket.suppliers) {
          if (supplier.ShopId) {
            ids.push(supplier.ShopId);
          }
        }
        let shopUrl = this.$router.resolve({
          path: "/enquiry",
          query: { ShopIdList: ids, IsDetail: true }
        });
        window.open(shopUrl.href, "_blank");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.basket {
  z-index: 99;
  width: 374px;
  position: fixed;
  right: 5%;
  bottom: 0;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 10px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  .basket-title {
    color: #fff;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    background: rgb(89, 89, 91);
    font-size: 17px;
    line-height: 44px;
    cursor: pointer;
    i {
      margin-right: 5px;
    }
    span {
      margin-right: 5px;
    }
  }
  .basket-container {
    background: #fff;
    .basket-content {
      height: 500px;
      overflow-y: scroll;
      padding-bottom: 20px;
      .product {
        margin-top: 20px;
        cursor: pointer;
        .product-left {
          width: 30%;
          vertical-align: middle;
          display: inline-block;
          .image {
            .el-image {
              width: 50px;
              height: 50px;
              .el-image__error {
                font-size: 10px;
              }
            }
          }
        }
        .product-right {
          width: 60%;
          vertical-align: middle;
          display: inline-block;

          .companyName {
            color: #aaaaaa;
            margin-bottom: 5px;
            font-size: 12px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .productName {
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .product-btns {
          width: 10%;
          vertical-align: middle;
          display: inline-block;
          .el-button {
            border: none;
            font-size: 20px;
            i {
              font-weight: bold;
            }
          }
        }
      }
      .supplier {
        margin-top: 20px;
        cursor: pointer;
        .supplier-left {
          width: 30%;
          vertical-align: middle;
          display: inline-block;
          .image {
            .el-image {
              width: 50px;
              height: 50px;
              .el-image__error {
                font-size: 10px;
              }
            }
          }
        }
        .supplier-right {
          width: 60%;
          vertical-align: middle;
          display: inline-block;

          .companyName {
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .supplier-btns {
          width: 10%;
          vertical-align: middle;
          display: inline-block;
          .el-button {
            border: none;
            font-size: 20px;
            i {
              font-weight: bold;
            }
          }
        }
      }
    }
    .basket-footer {
      width: 100%;
      padding: 3%;
      text-align: center;
      border-top: 1px solid rgb(204, 204, 204);
      .submit-button {
        font-size: 14px;
        border-radius: 10px;
        padding: 10px 50px;
        background: linear-gradient(270.13deg, #f58603 0.13%, #fb3f04 99.91%);
      }
      .clear-button {
        font-size: 14px;
        border-radius: 10px;
        padding: 10px 50px;
        background: rgb(204, 204, 204);
        color: #333;
      }
    }
    .basket-empty {
      display: block;
      text-align: center;
      width: 100%;
      margin-bottom: 20px;
      color: #999;
      ::v-deep .el-empty {
        margin-top: 30%;
        margin-bottom: 30%;
        .el-empty__image {
          margin: auto;
        }
        p {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
}
</style>
